import React from "react";
import "./BuyInputSection.css";
import { Trans } from "@lingui/macro";
import classes from './BuyInputStyles.module.scss';

export default function BuyInputSection(props) {
  const {
    topLeftLabel,
    topRightLabel,
    onClickTopRightLabel,
    inputValue,
    onInputValueChange,
    onClickMax,
    showMaxButton,
    balance,
    tokenBalance,
  } = props;

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.label}>{topLeftLabel}</div>
        <div className={classes.rightLabelWrapper} onClick={onClickTopRightLabel}>
          <span className={classes.rightLabel}>{topRightLabel}</span>&nbsp;
          <span className={classes.tokenBalance}>{tokenBalance}</span>
          {showMaxButton && (
            <div className={classes.maxButton} onClick={onClickMax}>
              <span><Trans>MAX</Trans></span>
            </div>
          )}
        </div>
      </div>
      <div className={classes.content}>
        <div className={classes.inputWrapper}>
          <input
            type="number"
            min="0"
            placeholder="0.0"
            className={classes.input}
            value={inputValue}
            onChange={onInputValueChange}
          />
        </div>
        <div className={classes.tokenSelector}>{props.children}</div>
      </div>
      <div className={classes.footer}>{balance}</div>
    </div>
  );
}
